import { FAMILY } from './families.js';

export const PLANT_TYPE = {
  RELIABLE: 'reliable',
  VARIABLE: 'variable'
};

export const PLANTS = [
  {
    id: 'diesel-generator',
    name: 'Diesel Generator',
    family: FAMILY.FOSSIL_THERMAL,
    type: PLANT_TYPE.RELIABLE,
    capital: 1,
    opex: 2.5,
    output: 4,
    averageOutput: 4,
    emissions: 6,
    role: 'Cheap dirty starter plant'
  },
  {
    id: 'combined-cycle-gas',
    name: 'Combined Cycle Gas',
    family: FAMILY.FOSSIL_THERMAL,
    type: PLANT_TYPE.RELIABLE,
    capital: 4,
    opex: 4,
    output: 8,
    averageOutput: 8,
    emissions: 4,
    role: 'Mid-game transition fuel'
  },
  {
    id: 'coal-plant',
    name: 'Coal Plant',
    family: FAMILY.FOSSIL_THERMAL,
    type: PLANT_TYPE.RELIABLE,
    capital: 3,
    opex: 4,
    output: 10,
    averageOutput: 10,
    emissions: 10,
    role: 'High output bargain trap',
    imageSrc: '/plant-images/Coal Powerplant.webp'
  },
  {
    id: 'carbon-capture-coal',
    name: 'Carbon Capture Coal',
    family: FAMILY.FOSSIL_THERMAL,
    type: PLANT_TYPE.RELIABLE,
    capital: 5,
    opex: 6,
    output: 9,
    averageOutput: 9,
    emissions: 3,
    role: 'Premium cleaned-up fossil',
    imageSrc: '/plant-images/CCC02.webp'
  },
  {
    id: 'geothermal',
    name: 'Geothermal',
    family: FAMILY.GEOTHERMAL,
    type: PLANT_TYPE.RELIABLE,
    capital: 6,
    opex: 2,
    output: 5,
    averageOutput: 5,
    emissions: 0,
    role: 'Mid-tier clean bridge'
  },
  {
    id: 'small-modular-nuclear',
    name: 'Small Modular Nuclear',
    family: FAMILY.NUCLEAR,
    type: PLANT_TYPE.RELIABLE,
    capital: 7,
    opex: 2,
    output: 7,
    averageOutput: 7,
    emissions: 0,
    role: 'Clean reliable stepping stone',
    imageSrc: '/plant-images/SMN.webp'
  },
  {
    id: 'large-nuclear',
    name: 'Large Nuclear',
    family: FAMILY.NUCLEAR,
    type: PLANT_TYPE.RELIABLE,
    capital: 12,
    opex: 2,
    output: 15,
    averageOutput: 15,
    emissions: 0,
    role: 'Premium clean powerhouse',
    imageSrc: '/plant-images/Large Nuclear.webp'
  },
  {
    id: 'large-hydro-dam',
    name: 'Large Hydro Dam',
    family: FAMILY.HYDRO,
    type: PLANT_TYPE.RELIABLE,
    capital: 12,
    opex: 2,
    output: 12,
    averageOutput: 12,
    emissions: 1,
    role: 'Premium clean, large scale',
    imageSrc: '/plant-images/Dam.webp'
  },
  {
    id: 'hydrogen',
    name: 'Hydrogen',
    family: FAMILY.GEOTHERMAL,
    type: PLANT_TYPE.RELIABLE,
    capital: 10,
    opex: 2.5,
    output: 6,
    averageOutput: 6,
    emissions: 0,
    role: 'Experimental clean dispatch',
    imageSrc: '/plant-images/Hydrogen.webp'
  },
  {
    id: 'solar-pv',
    name: 'Solar PV',
    family: FAMILY.SOLAR,
    type: PLANT_TYPE.VARIABLE,
    capital: 2,
    opex: 1,
    output: { min: 1, max: 5 },
    averageOutput: 3,
    emissions: -1,
    role: 'Cheapest capital, highest variance',
    imageSrc: '/plant-images/Solar PV.webp'
  },
  {
    id: 'concentrated-solar',
    name: 'Concentrated Solar',
    family: FAMILY.SOLAR,
    type: PLANT_TYPE.VARIABLE,
    capital: 5,
    opex: 1.5,
    output: { min: 3, max: 6 },
    averageOutput: 4.5,
    emissions: -1,
    role: 'Narrower range, thermal storage',
    imageSrc: '/plant-images/Concentration Solar.webp'
  },
  {
    id: 'onshore-wind',
    name: 'Onshore Wind',
    family: FAMILY.WIND,
    type: PLANT_TYPE.VARIABLE,
    capital: 3,
    opex: 1,
    output: { min: 2, max: 6 },
    averageOutput: 4,
    emissions: -1,
    role: 'Best value, moderate risk',
    imageSrc: '/plant-images/OnShore Wind.webp'
  },
  {
    id: 'offshore-wind',
    name: 'Offshore Wind',
    family: FAMILY.WIND,
    type: PLANT_TYPE.VARIABLE,
    capital: 7,
    opex: 2,
    output: { min: 4.5, max: 8 },
    averageOutput: 6.25,
    emissions: -2,
    role: 'Premium, more consistent',
    imageSrc: '/plant-images/Offshore Wind.webp'
  },
  {
    id: 'tidal',
    name: 'Tidal',
    family: FAMILY.OCEAN,
    type: PLANT_TYPE.VARIABLE,
    capital: 6,
    opex: 2,
    output: { min: 4, max: 7 },
    averageOutput: 5.5,
    emissions: -1,
    role: 'Most predictable variable',
    imageSrc: '/plant-images/Tidal.png'
  },
  {
    id: 'wave-power',
    name: 'Wave Power',
    family: FAMILY.OCEAN,
    type: PLANT_TYPE.VARIABLE,
    capital: 4,
    opex: 2,
    output: { min: 1, max: 7 },
    averageOutput: 4,
    emissions: -1,
    role: 'High variance wild card',
    imageSrc: '/plant-images/Wave.png'
  },
  {
    id: 'run-of-river-hydro',
    name: 'Run-of-River Hydro',
    family: FAMILY.HYDRO,
    type: PLANT_TYPE.VARIABLE,
    capital: 5,
    opex: 1,
    output: { min: 3, max: 7 },
    averageOutput: 5,
    emissions: 0,
    role: 'Good value, zero emissions',
    imageSrc: '/plant-images/River.webp'
  }
];

export const PLANT_BY_ID = Object.fromEntries(
  PLANTS.map((p) => [p.id, p])
);

export const PLANT_IDS = PLANTS.map((p) => p.id);

export const RELIABLE_PLANT_IDS = PLANTS
  .filter((p) => p.type === PLANT_TYPE.RELIABLE)
  .map((p) => p.id);

export const VARIABLE_PLANT_IDS = PLANTS
  .filter((p) => p.type === PLANT_TYPE.VARIABLE)
  .map((p) => p.id);

export const PLANT_IDS_BY_FAMILY = PLANTS.reduce((acc, p) => {
  if (!acc[p.family]) acc[p.family] = [];
  acc[p.family].push(p.id);
  return acc;
}, {});
